import { atlasRoutes } from "@/app/router/routes";
import { Button } from "@/components/button";
import { Table } from "@/components/table/table";
import { TextFieldRow } from "@/components/table/text-field-row";
import { UuidFieldRow } from "@/components/table/uuid-field-row";
import { UploadedImage } from "@/components/uploaded-image";
import { api } from "@/modules/api";
import { ColumnDef } from "@tanstack/react-table";
import { useQuery } from "@tanstack/react-query";
import { FC, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import styled from "@emotion/styled";
import { StaffMemberSchema } from "@/domains/openapi/types";

export const CompanyTeamPage: FC = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const pageSize = 50;

  const result = useQuery({
    queryKey: ["staff-members", query],
    queryFn: () =>
      api.post("/internal/v1/staff/members/search", {
        body: { query_string: query, limit: pageSize },
      }),
  });

  const data = result.data?.data?.results ?? [];

  const columns = useMemo<ColumnDef<StaffMemberSchema>[]>(
    () => [
      {
        header: "Photo",
        cell: ({ row }) => (
          <UploadedImage uploadedFileId={row.original.profile_photo_uploaded_file_id} size={32} />
        ),
      },
      {
        header: "ID",
        cell: ({ row }) => <UuidFieldRow id={row.original.id} />,
      },
      {
        header: "Name",
        cell: ({ row }) => <TextFieldRow value={row.original.profile_display_name} />,
      },
      {
        header: "Email",
        cell: ({ row }) => <TextFieldRow value={row.original.staff_email_address} />,
      },
      {
        header: "View",
        cell: ({ row }) => (
          <Button
            variant="outline"
            size="1"
            onClick={() =>
              navigate(
                atlasRoutes.companyTeamMember({ params: { staffMemberId: row.original.id } }).path
              )
            }
          >
            View
          </Button>
        ),
      },
    ],
    [navigate]
  );

  return (
    <Container>
      <h1>Team Members</h1>
      <input placeholder="Search" value={query} onChange={e => setQuery(e.target.value)} />
      <br />
      <Table data={data} columns={columns} pageSize={pageSize} />
    </Container>
  );
};

const Container = styled.div`
  padding: 20px;
`;
